import{MediaChannelEnum as t}from"../typings/algolia-data-types/products.js";const o=(o=t.Empty)=>o===t.Online||o===t.All;export{o as isWhereToBuyEnabledByMediaChannel};
